import React, { useState, useContext, useEffect } from "react";
import { Formik } from "formik";
import { Input } from "formik-antd";
import MultiStepFormContext from "./MultiStepFormContext";
import "./TimeBudget.css";
import './JobOnboarding.css';
import moment from 'moment';

const Details = () =>
{
  const { timeBudget, setTimeBudget, next, prev } = useContext(MultiStepFormContext);

  // Initialize local state from context
  const [selectedOption, setSelectedOption] = useState(timeBudget.deadline || "");
  const [date, setDate] = useState(timeBudget.deadlineDate || null);
  const [showDatePicker, setShowDatePicker] = useState(selectedOption === "Pick a Date");
  const [optionError, setOptionError] = useState('');

  const handleRadioChange = (e) =>
  {
    if (e.target.value === "Pick a Date")
    {
      setShowDatePicker(true);
    } else
    {
      setShowDatePicker(false);
    }
  };

  const handleOptionClick = (option) =>
  {
    setSelectedOption(option);
    if (option !== "Pick a Date")
    {
      setDate(null);
    }
  };

  useEffect(() =>
  {
    console.log("selected:", selectedOption);
  }, [selectedOption]);

  return (
    <Formik
      initialValues={timeBudget}
      onSubmit={(values) =>
      {
        if (selectedOption === "")
        {
          setOptionError("Please Select One");
          setTimeBudget(values);
        } else
        {
          setTimeBudget(prevState => ({
            ...prevState,
            ...values,
            deadline: selectedOption,
            deadlineDate: date, // Set the selected date
          }));
          console.log("setDetails:", timeBudget);
          next();
        }
      }}
      validate={(values) =>
      {
        const errors = {};
        if (!values.budgetAmount)
        {
          errors.budgetAmount = "What is Your Budget?";
        }
        if (!values.budget)
        {
          errors.budget = "Please Select Budget";
        }
        if (!values.siteVisit)
        {
          errors.siteVisit = "Please Select Site Visit Time";
        }
        return errors;
      }}
    >
      {({ handleSubmit, handleChange, values, errors, touched }) => (
        <div className="">
          <div className="form-main">
            <div className="form-row">
              {/* Budget Field */}
              <div className='form-group'>
                <label>Do you have a budget in mind?</label>
                <div className="form-control-wrapper form-input-icon">
                  <Input
                    type="number"
                    placeholder="Enter budget amount"
                    name="budgetAmount"
                    value={values.budgetAmount}
                    min={0}
                    onChange={(value) =>
                    {
                      const newValue = value.target.value;
                      if (newValue === '' || /^[0-9]*\.?[0-9]*$/.test(newValue))
                      {
                        handleChange({ target: { name: 'budgetAmount', value: newValue } });
                      }
                    }}
                    className="form-control"
                  />
                  <span>$</span>
                </div>
                {touched.budgetAmount && errors.budgetAmount && (
                  <p className="error__feedback">{errors.budgetAmount}</p>
                )}
              </div>

              {/* Budget Type Field */}
              <div className='form-group'>
                <label>Select a Budget</label>
                <select name="budget"
                  className="form-control"
                  placeholder="Select Budget"
                  mode="single"
                  value={values.budget}
                  bordered={false}
                  onChange={(value) => handleChange({ target: { name: 'budget', value: value.target.value } })}>
                  <option>Select budget</option>
                  <option value={"Under $100"}>Under $100 </option>
                  <option value={"$100 - $500"}>$100 - $500</option>
                  <option value={"$500 - $1000"}>$500 - $1000</option>
                  <option value={"$1000 - $2000"}>$1000 - $2000</option>
                  <option value={"$2000 - $5000"}>$2000 - $5000</option>
                  <option value={"Above $5000"}>Above $5000</option>
                </select>
                {touched.budget && errors.budget && (
                  <p className="error__feedback">{errors.budget}</p>
                )}
              </div>
            </div>
          </div>

          <div className="form-main">
            <div className="form-row">
              <div className="form-group">
                <label>When do you need this job done by?</label>
                <div className="select-check-radio">
                  <div
                    className={`profession-type-button ${selectedOption === "Urgently" ? "selected" : ""}`}
                    onClick={() => handleOptionClick("Urgently")}
                  >
                    Urgently
                  </div>
                  <div
                    className={`profession-type-button ${selectedOption === "Within 1 week" ? "selected" : ""}`}
                    onClick={() => handleOptionClick("Within 1 week")}
                  >
                    Within 1 week
                  </div>
                  <div
                    className={`profession-type-button ${selectedOption === "2 weeks or longer" ? "selected" : ""}`}
                    onClick={() => handleOptionClick("2 weeks or longer")}
                  >
                    2 weeks or longer
                  </div>
                  <div
                    className={`profession-type-button ${selectedOption === "Pick a Date" ? "date-selected selected" : ""}`}
                    onClick={() => handleOptionClick("Pick a Date")}
                  >
                    {selectedOption === "Pick a Date" ? (
                      <input type="date" name="deadlineDate"
                        className="profession-type-button"
                        placeholder="DD/MM/YYYY"
                        value={date ? moment(date).format('YYYY-MM-DD') : ''}
                        onChange={(value) =>
                        {
                          setDate(value.target.value);
                          handleChange({ target: { name: 'deadlineDate', value: value.target.value } });
                        }} />
                    ) : (
                      "Pick a Date"
                    )}
                  </div>
                </div>
                {optionError && (
                  <p className="error__feedback">{optionError}</p>
                )}
              </div>
            </div>
          </div>

          {/* Site Visit Times Field */}
          <div className="form-main">
            <div className="form-row">
              <div className="form-group">
                <label>Site Visit Times</label>
                <select
                  className="form-control"
                  bordered={false}
                  name="siteVisit"
                  placeholder="Select"
                  mode="single"
                  value={values.siteVisit}
                  onChange={(value) => handleChange({ target: { name: 'siteVisit', value: value.target.value } })}
                >
                  <option>Select theme</option>
                  <option value={"Anytime"}>Anytime</option>
                  <option value={"Weekdays"}>Weekdays</option>
                  <option value={"After business hours"}>After business hours</option>
                  <option value={"Weekends"}>Weekends</option>
                  <option value={"No site visit"}>No site visit</option>
                </select>
                {touched.siteVisit && errors.siteVisit && (
                  <p className="error__feedback">{errors.siteVisit}</p>
                )}
              </div>
            </div>
          </div>

          {/* Navigation Buttons */}
          <div className="onboarding-form-button">
            <button type="button" onClick={prev}>Back</button>
            <button type="button" onClick={handleSubmit}>Next</button>
          </div>
        </div>
      )}
    </Formik>
  );
};

export default Details;
